import * as React from "react";
import classnames from "classnames";
import { StickyMobileCtaAndPrice } from "../../../../../../../../../StickyCta/modules/StickyCta/StickyMobileCtaAndPrice.js";
import { LensesPerBoxText } from "../../../../../../CLText/LensesPerBoxText/modules/EcommContent/ContactLensesEcommContent/components/CLText/LensesPerBoxText/LensesPerBoxText.js";
import { ContactLensesCTA } from "../../../../../../ContactLensesCTA/modules/EcommContent/ContactLensesEcommContent/components/ContactLensesCTA/ContactLensesCTA.js";
import { useContactLensProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const ContactLensesStickyCTA = ({ className }) => {
  const { activeVariant } = useContactLensProductData();
  const { lensesPerBox } = activeVariant;
  return /* @__PURE__ */ React.createElement(
    StickyMobileCtaAndPrice,
    {
      className: classnames("contact-lenses-sticky-cta", className),
      cta: /* @__PURE__ */ React.createElement(ContactLensesCTA, { className: "contact-lenses-sticky-cta__button" }),
      priceSubtitle: /* @__PURE__ */ React.createElement(LensesPerBoxText, { lensesPerBox })
    }
  );
};
export {
  ContactLensesStickyCTA
};
//# sourceMappingURL=ContactLensesStickyCTA.js.map
